export default __webpack_public_path__ + "static/media/bestAndWorstCategories.c95df9dd.png";